import(/* webpackMode: "eager" */ "/vercel/path0/app/support/technical/page.tsx");
